import { NavigationExtras } from '@angular/router';
import { createAction, props } from '@ngrx/store';

export const go = createAction('[ROUTER] GO', props<{ path: Array<string>, extras?: NavigationExtras }>());
export const back = createAction('[ROUTER] BACK');
export const forward = createAction('[ROUTER] FORWARD');
export const goOutside = createAction('[ROUTER] GO_OUTSIDE', props<{ url: string }>());
export const openNewTab = createAction('[ROUTER] OPEN_NEW_TAB', props<{ url?: string }>());
